import * as z from "zod";

export const uploadProductFamilyImages = {
  name: "uploadProductFamilyImages" as const,
  input: z.object({}),
  output: z.object({ urls: z.array(z.string()) }),
};
